/* @flow */
import { combineReducers } from 'redux-immutable';
import { OrderedMap, Map, Set, fromJS } from 'immutable';
import type { Action } from 'trustar/utils/redux-types.js';

import {

  FETCH_ENTITY_TYPES_SUCCESS,

  FETCH_CREDENTIALS_TYPES_SUCCESS,
  FETCH_ACCESS_TYPES_SUCCESS,
  FETCH_LABELS_SUCCESS,
  FETCH_SUBSCRIPTION_METHODS_SUCCESS,

  TOGGLE_ENTITY_TYPE,

} from './action-types.js';

type State = OrderedMap<string, any>;


export const entityTypes = (state: OrderedMap<string, Object> = OrderedMap(), action: Action<*>) => {
  const { type, payload } = action;

  switch (type) {
  case FETCH_ENTITY_TYPES_SUCCESS:
    return payload;
  default:
    return state;
  }
};

/**
 * The entity types that are currently selected in the form UI
 *
 * NOTE: Default to non-custom entity types. In this context "standard" just
 * means the entity type is not custom.
 */
export const selectedEntityTypes = (state: Set<string> = Set(), action: Action<*>) => {
  const { type, payload, meta } = action;

  switch (type) {
  case TOGGLE_ENTITY_TYPE: {
    const { guid } = payload;
    return state.has(guid) ? state.delete(guid) : state.add(guid);
  }

  case FETCH_ENTITY_TYPES_SUCCESS: {
    const standardEntityTypes = payload.filter(x => x.get('default')).keySeq().toSet();
    const allEntityTypes = payload.keySeq().toSet();

    if (meta && meta.existingEntityTypes) {
      return allEntityTypes.intersect(meta.existingEntityTypes);
    } else {
      return standardEntityTypes; // See NOTE
    }
  }

  default:
    return state;
  }
};

export const credentialsTypes = (state: State = OrderedMap(), action: Action<*>) => {
  const { type, payload } = action;

  switch (type) {
  case FETCH_CREDENTIALS_TYPES_SUCCESS:
    return fromJS(payload)
      .toMap()
      .mapEntries(([k, v]) => {
        const credentialsType = v.get('credentialsType');
        const credentials = v
        .mapKeys((k, v) => (k === 'credentialsType') ? 'value' : k)
        .set('label', k);
        return [credentialsType, credentials];
      });
  default:
    return state;
  }
};

export const accessTypes = (state: State = OrderedMap(), action: Action<*>) => {
  const { type, payload } = action;

  switch (type) {
  case FETCH_ACCESS_TYPES_SUCCESS:
    return fromJS(payload)
      .toMap()
      .mapEntries(([k, v]) => [k, Map({ label: v, value: k })]);
  default:
    return state;
  }
};

export const labels = (state: State = OrderedMap(), action: Action<*>) => {
  const { type, payload } = action;

  switch (type) {
  case FETCH_LABELS_SUCCESS:
    return fromJS(payload)
      .toMap()
      .mapEntries(([k, v]) => [k, Map({ label: v, value: k })]);
  default:
    return state;
  }
};

export const subscriptionMethods = (state: State = OrderedMap(), action: Action<*>) => {
  const { type, payload } = action;

  switch (type) {
  case FETCH_SUBSCRIPTION_METHODS_SUCCESS:
    return Map(payload.map(x => [x.value, fromJS(x)]));
  default:
    return state;
  }
};

export default combineReducers({
  entityTypes,
  selectedEntityTypes,
  credentialsTypes,
  accessTypes,
  labels,
  subscriptionMethods,
});



// WEBPACK FOOTER //
// ./src/app/modules/miscellaneous/stores.js